import { combineReducers } from 'redux'
import DataDirectoryReducer from './dataDirectory'
import ContextPaneReducer from './context'
import UserReducer from './user'

const rootReducer = combineReducers({
  dataDirectory: DataDirectoryReducer,
  contextPane: ContextPaneReducer,
  user: UserReducer,
})

export default rootReducer
